import axios from 'axios';
import config from '../config';

const addReview = async data => {
  const res = await axios.post(`${config.API_URL}/api/properties/${data.propertyId}/reviews/`, data);
  return res;
};

export default addReview;
